import { useQuery } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import { CustomEmailTemplateDetailModel } from '../../models/customEmailTemplates.model';

// services
import API from '../../services/api';

// constants
import queryKeys from './_querykeys';

const getEmailTemplateDetail = async (
    templateId: string,
): Promise<CustomEmailTemplateDetailModel> => {
    const { data } = await API.customEmailTemplateDetail(templateId);
    return data;
};

export default function useCustomEmailTemplateDetail(
    templateId: string,
    enabled: boolean = true,
) {
    return useQuery<CustomEmailTemplateDetailModel, BaseError>({
        queryKey: queryKeys.detail(templateId),
        queryFn: () => getEmailTemplateDetail(templateId),
        enabled: enabled && !!templateId,
    });
}
